import React from 'react';
import { getConditions, getCurrentUser, getCurrentUserId, getIngredients, getMeds, getMedsHistory, getSupplements } from 'store/storeValtio';
import chevLeft from 'icons/chevron-left-24.png';
import { useNavigate } from 'react-router-dom';

export default function ExportUser() {
  console.log('ExportUser');
  const navigate = useNavigate();

  const user = getCurrentUser();
  let userData = '"user":';
  userData += JSON.stringify(user);

  const meds = getMeds();
  let medsData = '"medications":';
  medsData += JSON.stringify(meds);
  
  const hist = getMedsHistory();
  let histData = '"history":';
  histData += JSON.stringify(hist);

  const cond = getConditions();
  let condData = '"conditions":';
  condData += JSON.stringify(cond);

  const supps = getSupplements();
  let suppsData = '"supplements":';
  suppsData += JSON.stringify(supps);

  const ings = getIngredients();
  let ingData = '"ingredients":';
  ingData += JSON.stringify(ings);


  let json = '{';
  json += userData;
  json += ',';
  json += medsData;
  json += ',';
  json += histData;
  json += ',';
  json += condData;
  json += ',';
  json += suppsData;
  json += ',';
  json += ingData;
  json += '}';
//  console.log(json);

  function handleExport() {
    exportData(json);
  }

  function exportData(data) {
    // this exports the file to the "download" folder
    const jsonString = `data:text/json;chatset=utf-8,${data}`;
    const link = document.createElement("a");
    link.href = jsonString;
    link.download = "itookitwhen.json";
    link.click();
  };

  function downloadObjectAsJson(exportObj, exportName){
    var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(exportObj));
    var downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute("href",     dataStr);
    downloadAnchorNode.setAttribute("download", exportName + ".json");
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  }

  return (
    <div className='mcard'>
      <div className='mcard-screen flex justify-between h-100'>
        <div className='hover:cursor-pointer' onClick={()=>navigate(-1)}>
          <img src={chevLeft} alt='' />
        </div>
        <div className='w-full pl-4'>
          <div className='text-xl '>Export User Data to JSON</div>
        </div>
      </div>
      <div className='w-full h-full pt-40 flex justify-center'>
        <button 
          className='rawBtn w-60 h-8 bg-blue-400'
          onClick={()=>handleExport()}
        >
          Export User Data
        </button>
      </div>
    </div>
  );
}
